import React from 'react';
import './CsvExportButton.css';
import excelIcon from '../../common/icons/excel.png';
import { exportToCsv } from '../../common/utils/csvUtils';

const CsvExportButton = ({
  data,
  getData,
  columns,
  fileName,
  disabled = false,
  emptyMessage = 'No data to export',
  title = 'Export to CSV',
  className = '',
  includeTimestamp = true,
}) => {
  const handleExport = () => {
    const rows = typeof getData === 'function' ? getData() : data;

    if (!Array.isArray(rows) || !rows.length) {
      alert(emptyMessage);
      return;
    }

    if (!columns?.length || !fileName) {
      console.error('CsvExportButton requires columns and fileName');
      return;
    }

    exportToCsv({
      data: rows,
      columns,
      fileName,
      includeTimestamp,
    });
  };

  return (
    <button
      type='button'
      className={`csv-export-btn ${className}`.trim()}
      onClick={handleExport}
      disabled={disabled}
      title={title}
      aria-label={title}
    >
      <img src={excelIcon} alt='' />
    </button>
  );
};

export default CsvExportButton;
